import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../util/responseUtil';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { CheckPermissionApi, CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_ROOT_CAUSE_UPDATE, TICKET_LIST_ALL_ROOT_CAUSE_UPDATE_ASSIGNEE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import Alert from '../Alert/Alert';
import ActionType from '../../redux/reducer/globalActionType';

class TicketRootCause extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rootCause: {
                page: 1,
                limit: 100,
                data: [],
                value: 0
            },
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getListRootCause = () => {
        API_TICKET_LIST.getListRootCauseTicketAll(this.state.rootCause.page, this.state.rootCause.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        rootCause: {
                            ...this.state.rootCause,
                            data: getContent(res)
                        }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleChangeRootCause = e => {
        this.setState({
            rootCause: {
                ...this.state.rootCause,
                value: e.target.value
            },
            showConfirmAlert: true
        })
    }

    handleSubmit = () => {
        const data = {
            root_cause: this.state.rootCause.value,
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataTicketRootCause(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlert: false
                })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                this.props.refresh();
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlert: false
                })
            }))
    }

    componentDidMount() {
        this._isMounted = true;

        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) this.getListRootCause();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    rootCauseWithRootCauseIdReadOnly = () => {
        return (
            <select id="ddlrootcause" className="outline-none custom-select select-rtl my-1" disabled>
                <option className="option-rtl" value="0">{this.props.data.root_cause_description}</option>
            </select>
        )
    }

    rootCauseWithoutRootCauseIdReadOnly = () => {
        return (
            <select id="ddlunselected" className="outline-none custom-select select-rtl my-1" disabled>
                <option className="option-rtl" value="0">-</option>
            </select>
        )
    }

    checkCustomerServiceAssignee = () => {
        if (CheckPermissionApi(TICKET_LIST_ALL_ROOT_CAUSE_UPDATE, this.props.userDetail.permissions) || CheckPermissionApi(TICKET_LIST_ALL_ROOT_CAUSE_UPDATE_ASSIGNEE, this.props.userDetail.permissions)) {
            if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.props.data.assignee_id) return false
            return true
        }
    }

    render() {
        return (
            <>
                {
                    this.props.data.root_cause_id !== ''
                        ? this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && this.checkCustomerServiceAssignee()
                            ? <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_ROOT_CAUSE_UPDATE, TICKET_LIST_ALL_ROOT_CAUSE_UPDATE_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                                <select id="ddlrootcause" className="outline-none custom-select select-rtl my-1" onChange={this.handleChangeRootCause} disabled={this.props.data.status !== STATUS_TICKET_CONSTANT.IN_PROGRESS} value={this.props.data.root_cause_id}>
                                    {
                                        this.state.rootCause.data.map(data =>
                                            <option key={data.id} className="option-rtl" value={data.remark}>{data.description}</option>
                                        )
                                    }
                                </select>
                            </CheckPermissionComponent>
                            : <this.rootCauseWithRootCauseIdReadOnly />
                        : this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && this.checkCustomerServiceAssignee()
                            ? <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_ROOT_CAUSE_UPDATE, TICKET_LIST_ALL_ROOT_CAUSE_UPDATE_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                                <select id="ddlrootcause" className="outline-none custom-select select-rtl my-1" onChange={this.handleChangeRootCause}>
                                    <option className="option-rtl" value="0"> - Pilih Root Cause -</option>
                                    {
                                        this.state.rootCause.data.map(data =>
                                            <option key={data.id} className="option-rtl" value={data.remark}>{data.description}</option>
                                        )
                                    }
                                </select>
                            </CheckPermissionComponent>
                            : <this.rootCauseWithoutRootCauseIdReadOnly />
                }
                <Alert show={this.state.showConfirmAlert} icon="warning" button={true} title="Apakah Anda yakin melakukan perubahan penyebab masalah?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleSubmit()} />
                <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketRootCause);